import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {AppSettings} from '../../proyect.conf';
import {map} from 'rxjs/operators';
import {FlujoVentaPasoVinculacion} from '../_models/flujo-venta-paso-vinculacion';
import {FlujoVentaPasoTiposPersonas} from '../_models/flujo-venta-paso-tipos-personas';

@Injectable({
  providedIn: 'root'
})
export class FlujoVentaPasoTiposPersonasService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/flujoVentaPasosTiposPersonas';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FlujoVentaPasoTiposPersonas[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FlujoVentaPasoTiposPersonas[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FlujoVentaPasoTiposPersonas ) );
  }

  listadoPorIdFlujoPaso( id: string ) {
    return this.httClient.get( this.rutServicio + '/idFlujoVentaPaso/' + id ).pipe( map( res => res as FlujoVentaPasoTiposPersonas[] ) );
  }

  crear( regCrear: FlujoVentaPasoTiposPersonas ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as FlujoVentaPasoTiposPersonas ) );
  }

  actualizar( regActualizar: FlujoVentaPasoTiposPersonas ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as FlujoVentaPasoTiposPersonas ) );
  }

  bulk( registros: FlujoVentaPasoTiposPersonas[] ) {
    registros.forEach( e => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( `${ this.rutServicio }/bulk`, registros ).pipe( map( res => res as FlujoVentaPasoTiposPersonas[] ) );
  }
}
